import React from 'react';
import Eyebrow from './Eyebrow';

interface SectionHeadProps {
  eyebrow: string;
  title: string;
  size?: number;
  trailing?: React.ReactNode;
  className?: string;
}

/**
 * Eyebrow + display sub-head row, with an optional trailing node (e.g. a
 * {@link TextLink}) pinned to the right baseline.
 *
 * The title is a raw `<h3>` carrying the display classes rather than a nested
 * `<DisplayHeading>`: DisplayHeading locks its font-size via an inline style at
 * a 32px floor, which cannot be shrunk to the 20-24px used here.
 */
const SectionHead: React.FC<SectionHeadProps> = ({
  eyebrow,
  title,
  size = 24,
  trailing,
  className = '',
}) => (
  <div className={`flex items-end justify-between gap-4 mb-[18px] ${className}`.trim()}>
    <div>
      <Eyebrow className="block mb-[9px]">{eyebrow}</Eyebrow>
      <h3
        className="font-we-display font-black tracking-[-0.02em]"
        style={{ fontSize: size, lineHeight: 1.05 }}
      >
        {title}
      </h3>
    </div>
    {trailing}
  </div>
);

export default SectionHead;
